import * as Yup from 'yup';

export const basicAddress = Yup.object({
  city: Yup.string().nullable(),
  comment: Yup.string().nullable(),
  coordinates: Yup.object({ x: Yup.number(), y: Yup.number() }).nullable(),
  countryCode: Yup.string().nullable(),
  district: Yup.number().nullable(),
  door: Yup.string().nullable(),
  floor: Yup.string().nullable(),
  fullAddress: Yup.string().nullable(),
  houseLetter: Yup.string().nullable(),
  houseNo: Yup.number().nullable(),
  pOIId: Yup.number().nullable(),
  pOIName: Yup.string().nullable(),
  poiname: Yup.string().nullable(),
  streetID: Yup.number().nullable(),
  streetName: Yup.string().nullable(),
  type: Yup.string().nullable(),
  zipCode: Yup.string().nullable(),
});
